var map = {
	"./icon-01.png": "eaZ/",
	"./icon-02.png": "WCtz",
	"./icon-03.png": "Wvmn",
	"./icon-04.png": "MvXV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iYQ6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reason ^\.\/.*$
// module id = iYQ6
// module chunks = 1